import { ReactNode } from 'react';
import * as Primitive from '@radix-ui/react-dialog';
import { X } from 'lucide-react';

import { Button } from '@components/primitives/Button';

import css from './Dialog.module.css';

export interface DialogHeaderProps {
  icon?: ReactNode;
  title: ReactNode;
}

export function DialogHeader({ title, icon }: DialogHeaderProps) {
  return (
    <header className={css.header}>
      {icon && <div className={css.headerIcon}>{icon}</div>}
      <Primitive.Title className={css.headerTitle}>{title}</Primitive.Title>
      <Primitive.Close asChild data-id="dialog-close">
        <Button size="xs" ghost flush aria-label="Close">
          <X aria-hidden />
        </Button>
      </Primitive.Close>
    </header>
  );
}
